import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ClientService, FilerInformationService } from "../services";
import { map, switchMap } from "rxjs/operators";
import { MasterUrlService } from "..";

export const ElectionCycleActiveGuard: CanActivateFn = () => {
    const client = inject(ClientService);
    const filer = inject(FilerInformationService);
    const url = inject(MasterUrlService).checkIfExistElectionCycleActive;

    return filer.current$.pipe(
        switchMap(({ filerId }) => client.getWithData(url, { filerId })),
        map((it) => it === true)
    );
}
